import { ACTIVE, IN_ACTIVE, SUNSET, PLANNED, enumInventoryStatuses } from "../consts/inventoryStatus";

const statusPalette = {
    [ACTIVE]: { chip: "bg-green-100 text-green-700", dot: "bg-green-600" },
    [IN_ACTIVE]: { chip: "bg-gray-100 text-gray-600", dot: "bg-gray-500" },
    [PLANNED]: { chip: "bg-blue-100 text-blue-700", dot: "bg-blue-600" },
    [SUNSET]: { chip: "bg-red-100 text-red-700", dot: "bg-red-600" },
};

export default function InventoryStatusChip({ status, className = "" }) {
    const colors = statusPalette[status] || statusPalette[IN_ACTIVE];

    return (
        <span
            className={`inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-[11px] font-medium leading-4 ${colors.chip} ${className}`.trim()}
        >
            <span className={`h-1.5 w-1.5 shrink-0 rounded-full ${colors.dot}`} aria-hidden />
            {enumInventoryStatuses[status] || "-"}
        </span>
    );
}
